import React from 'react'
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import ViewportRecaptcha from "../../components/ViewportRecaptcha";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import { dialCodeForCountry, getClientLocation } from "../../helper/clientLocation";

export default function HomeContact({ setShow, title, heading }) {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [country, setCountry] = useState("us");
  const [checked, setChecked] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "+1 - ",
    email: "",
    interest: "",
    message: "",
    source_url: "",
    current_url: "",
    countryCode: "US",
    country_name: "United States",
    ip_address: "",
  })



  useEffect(() => {
    const existingSource = sessionStorage.getItem("source_url");
    const currentUrl = window.location.href;

    if (!existingSource) {
      const landingUrl = window.location.href;
      sessionStorage.setItem("source_url", landingUrl);

      setFormData((prev) => ({
        ...prev,
        source_url: landingUrl,
        current_url: currentUrl,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        source_url: existingSource,
        current_url: currentUrl,
      }));
    }

  }, []);




   useEffect(() => {
   let active = true;
   getClientLocation().then((data) => {
     if (!active) return;
     const code = (data.country_code || "US").toLowerCase();
 
     setCountry(code);
 
     setFormData((prev) => ({
       ...prev,
       phoneNumber: `${dialCodeForCountry(code)} - `,
       countryCode: (data.country_code || "US"),
       country_name: data.country_name || "United States",
       ip_address: data.ip || "",
     }));
   });
 
   return () => {
     active = false;
   };
 }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      // allow only digits
      const numericValue = value.replace(/\D/g, "");
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };


  const handleCaptcha = (value) => {
    setCaptchaToken(value);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.interest) {
      toast.error("Please select a service");
      return;
    }

    if (!checked) {
      toast.error("Please accept the privacy policy");
      return;
    }

    if (!captchaToken) {
      toast.error("Please complete the CAPTCHA");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/contact/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.error === false) {
        if (setShow) {
          setShow(false);
        }
        navigate("/thank-you");
      } else {
        toast.error(result.message);
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <section className="home-contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="contact-text heading-center">
                <div className="heading-gap">
                  <span className="subtitle">{title || "Contact us"}</span>
                  <h2 className="heading">
                    {heading || (
                      <>
                        The Partner You Need, with the <br /> Support You Deserve.
                      </>
                    )}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-md-12 col-lg-7">
              <div className="form-wrapper">
                <form onSubmit={handleSubmit} className="form">
                  <div className="row">
                    <div className="col-md-12">
                      <div className={`form-field  ${!formData.name ? "" : "valid"}`}>
                        <label>Full Name <span>*</span></label>
                        <input name="name" type="text" className="form-control" value={formData.name} onChange={handleChange} placeholder="Full Name" required />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className={`form-field  ${!formData.email ? "" : "valid"}`} >
                        <label>Business Email<span>*</span></label>
                        <input name="email" type="email" className="form-control" value={formData.email} onChange={handleChange} placeholder="Business Email" required />
                      </div>
                    </div>


                    <div className="col-md-6">
                      <div className={`form-field ${!formData.phoneNumber ? '' : 'valid'}`} >
                        <label>Mobile Number<span>*</span></label>
                        <div className="conform-phone-wrap">
                          <div className="country-text-wrap">
                             <PhoneInput
                    key={country}
                    country={country}
                    value={formData.phoneNumber.split('-')[0]?.trim() || ''}
                    onChange={(value, countryData) => {
                      const dialCode = `+${countryData.dialCode}`;
                      setFormData((prev) => ({
                        ...prev,

                        // phone
                        phoneNumber: prev.phoneNumber
                          ? `${dialCode} - ${prev.phoneNumber.split('-')[1]?.trim() || ''}`
                          : `${dialCode} - `,
                        // country details
                        countryCode: countryData.countryCode?.toUpperCase(),
                        country_name: countryData.name,
                      }));
                    }}
                    disableDropdown={false}
                    disableCountryCode={true}
                    buttonClass="country-selector"
                  />

                          </div>

                          <div className="phone-wrapper">
                            <input type="tel" name="phoneNumber" className="form-control phone-numbers" placeholder="Phone Number"
                              value={formData.phoneNumber.split('-')[1]?.trim() || ''}
                              onChange={(e) =>
                                setFormData((prev) => {
                                  const dialCode = prev.phoneNumber.split('-')[0]?.trim() || '+91';
                                  const numericValue = e.target.value.replace(/\D/g, "");
                                  return {
                                    ...prev,
                                    phoneNumber: `${dialCode} - ${numericValue}`,
                                  };
                                })
                              }
                              inputMode="numeric" required />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="col-half">
                        <div className="form-field ">
                          <label>Services<span>*</span></label>
                          <select name="interest" className="form-control" value={formData.interest} onChange={handleChange} required>
                            <option value="" disabled>Select Services</option>
                            <option value="Warehouse Management System">Warehouse Management System </option>
                            <option value="Route optimisation and planning">Route optimisation and planning </option>
                            <option value="First, mid and last mile delivery">First, mid and last mile delivery</option>
                            <option value="Multi-carrier management">Multi-carrier management</option>
                            <option value="Transportation Management System">Transportation Management System </option>
                            <option value="On demand delivery management">On demand delivery management</option>
                            <option value="International logistics">International logistics</option>
                            <option value="Container tracking platform">Container tracking platform</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className={`form-field ${!formData.message ? "" : "valid"}`}>
                        <label>Any Other Detail for Us<span>*</span></label>
                        <textarea className="form-control" name="message" value={formData.message} onChange={handleChange} rows={2} placeholder="Your message...." required ></textarea>
                      </div>

                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <div className="checkbox-inner">
                          <input
                            type="checkbox"
                            className="checkbox-wrap"
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                          />
                          <p>
                            By submitting this form I consent to Mobility storing my submitted information so they can respond to my inquiry. Learn more in our{" "}
                            <Link to="/privacy-policy" className="privacy-link">
                              Privacy Policy
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="col-md-12">
                      <div style={{ marginTop: "10px", marginLeft: "0px", marginBottom: "20px", }}>
                        <ViewportRecaptcha sitekey="6Ldi_QgsAAAAAA4a6l45zI5f4WXGToxTKR6lM2dH" onChange={handleCaptcha} />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-btn">
                        <button style={{ opacity: loading ? "0.3" : "1" }} disabled={loading} type="submit" className="theme-btn" > <span> {loading ? "Submitting..." : "Submit"}</span> </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-12 col-lg-5">
              <div className="form-deatils">
                <div className="col-items-first">
                  <div className="main-heading">What happens now?  </div>
                  <p>We're here to make things simpler for you. We won't spam your inbox or blow up your phone. When you enter your information:</p>
                </div>
                <div className="col-items">
                  <div className="circle-wrapper">
                    <div className="circle-number">
                      <span>01 </span>
                    </div>
                  </div>
                  <p> <span>(Within 24 hours)</span> A dedicated member of the Mobility Infotech team will carefully read your request & schedule a meeting by email. A more in-depth form will also be thoughtfully attached to the email.</p>
                </div>
                <div className="col-items">
                  <div className="circle-wrapper">
                    <div className="circle-number">
                      <span>02 </span>
                    </div>
                  </div>
                  <p> We will ask you about your needs & specific logistics requirements in detail to better understand your business model and long-term operational goals.</p>
                </div>
                <div className="col-items">
                  <div className="circle-wrapper">
                    <div className="circle-number">
                      <span>03</span>
                    </div>
                  </div>
                  <p>We will take your information and put together a fully customized, data-driven logistics plan designed specifically to enhance your business efficiency and scalability.</p>
                </div>
                <div className="form-address">
                  <Link className="footer-link" to="tel:+1 (518) 719-2882">
                    <span><i className="fa-solid fa-phone"></i></span> +1 (518) 719-2882  </Link>
                  <Link className="footer-link" to="mailto:sales@mobilityinfotech.com"  >
                    <span><i className="fa-solid fa-envelope"></i></span> sales@mobilityinfotech.com </Link>
                </div>
                <div className="form-social">
                  <div className="form-social-inner">
                    <p>Follow Us on:</p>
                    <ul className="form-social-items">
                      <li><Link to={"https://www.facebook.com/profile.php?id=61565074738395"} target="_blank"><i className="fab fa-facebook-f"></i> </Link></li>
                      <li><Link to={"https://www.instagram.com/mobility_infotech/"} target="_blank"><i className="fab fa-instagram"></i> </Link></li>
                      <li><Link to={"https://www.linkedin.com/company/mobility-infotech-pvt-ltd/"} target="_blank"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                      <li><Link to={"https://www.youtube.com/@MobilityInfotech"} target="_blank"><i className="fab fa-youtube"></i> </Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
